export function isLiveBlogValue(value: unknown): boolean {
  if (value === true) return true;

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "true" || normalized === "live-blog";
  }

  return false;
}
